import { hash } from '@ember/helper';
import { service } from '@ember/service';

import CpPanel from 'ember-collapsible-panel/components/cp-panel/component';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsDivisionComponent extends Component {
  // Services
  @service data;

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='name' />
            <fieldset.field @property='shortName' />

            <fieldset.field @property='text' @type='text-editor' />
          </form.fieldset>
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field
              @property='organization'
              @type='belongs-to'
              @on={{hash openNewRecord=false openRecord=false}}
            />

            <fieldset.field
              @property='externalReferences'
              @type='has-many'
              @hasManySortable={{false}}
              @on={{hash
                openNewRecord=this.newRecord
                removeRecord=this.deleteRelation
                openRecord=false
                openRecordList=false
              }}
              as |record field|
            >
              <CpPanel @open={{record.isNew}} as |panel|>
                <panel.toggle>
                  {{record.type.name}}
                  |
                  {{record.val}}
                </panel.toggle>
                <panel.body>
                  <Form
                    @model={{record}}
                    @parentModel={{form.model}}
                    @showErrors={{@showErrors}}
                    as |subform|
                  >
                    <subform.field
                      @property='type'
                      @type='select-record'
                      @disabled={{field.isDisabled}}
                      @isSearchEnabled={{true}}
                      @options={{this.data.externalReferenceServices}}
                    />
                    <subform.field
                      @property='val'
                      @disabled={{field.isDisabled}}
                    />
                    <subform.field
                      @property='param'
                      @disabled={{field.isDisabled}}
                    />
                  </Form>
                </panel.body>
              </CpPanel>
            </fieldset.field>
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
